module.exports = __webpack_public_path__ + "img/banner4.3b0b50e3.jpg";